// Don't change class names as CSS styles are associated with it

const events = {
  devjams: {
    name: "DevJams'21",
    dateRange: '20th - 22nd November',
    month: '',
    content:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero odit praesentium facilis non placeat nisi inventore sapiente nulla alias dolores',
    classname: 'devjams-grid'
  },
  devtalks: {
    name: 'DevTalks 21',
    date: '13th Nov',
    content:
      'Interact and meet with a few of the most prestigious and renowned figures in the ever-changing tech industry!',
    classname: 'devtalks-grid',
    coords: { circle1: '-top-32 -right-0', circle2: '-bottom-20 left-0' },
    link: 'https://gdsc.community.dev/events/details/developer-student-clubs-vellore-institute-of-technology-vit-vellore-presents-devtalks21/'
  },
  knockathon: {
    name: 'Knockathons 21',
    date: '9th - 10th Oct',
    content:
      'Have what it takes to be a winner? Team up with your friends to solve an innovative problem and pitch your ideas while competing against other teams to come out on top!',
    classname: 'knockathon-grid',
    coords: { circle1: '-top-32 -right-20', circle2: '-bottom-20 -left-20' },
    link: 'https://portal.devjams.dscvit.com/'
  },
  ctf: {
    name: 'DeconstruCTF',
    date: '1st - 2nd Oct',
    content:
      'A 24 hour jeopardy style CTF, ranging to five different domains, namely, web, forensics, cryptography, OSINT and miscellaneous!',
    classname: 'ctf-grid',
    coords: { circle1: '-top-0 -right-32', circle2: '-bottom-20 -left-20' },
    link: 'https://ctf.dscvit.com/'
  },
  hexathon: {
    name: 'Hexathon',
    date: '27th - 28th Nov',
    content:
      'Channel your inner passion and creativity to create innovative and ingenious design solutions to current problems and win exciting prizes!',
    classname: 'hexathon-grid',
    coords: { circle1: '-top-32 -right-32', circle2: 'bottom-10 -left-20' },
    link: 'https://portal.devjams.dscvit.com/'
  }
}

export default events
